import {
  faPencil,
  faTrashCan,
  faEllipsisV,
} from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Flex, Menu } from '@mantine/core'

import {
  useMutationDeleteBookingProduct,
  useQueryGetBookingById,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type CoreBookingProduct } from '@flecto/types'
import { Icon, useNotifications } from '@flecto/ui'

import { useModalBookingProductUpdate } from '../../hooks/useModalBookingProductUpdate'
import { CardBookingProductPreview } from '../CardBookingProductPreview/CardBookingProductPreview'

export type CellActionsProps = {
  bookingProduct?: CoreBookingProduct
}

export function CellActions({ bookingProduct }: CellActionsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })

  const { showNotification } = useNotifications()

  const { data: booking } = useQueryGetBookingById({
    bookingId: bookingProduct?.booking?.internal_id,
  })

  const { openModal: openModalUpdate } = useModalBookingProductUpdate({
    bookingProduct,
  })

  const { mutateAsync: deleteProduct, isLoading: isDeleting } =
    useMutationDeleteBookingProduct()

  const handleDeleteProduct = async () => {
    try {
      await deleteProduct({
        bookingId: bookingProduct?.booking?.internal_id,
        productId: bookingProduct?.id,
      })

      showNotification({
        type: 'success',
        message: t('notification_remove_booking_item_success'),
      })
    } catch {
      showNotification({
        type: 'error',
        message: t('notification_remove_booking_item_error'),
      })
    }
  }

  return (
    <Flex justify='center' align='center'>
      {booking?.status !== 'completed' && booking?.status !== 'canceled' && (
        <ActionIcon onClick={openModalUpdate} size='xs'>
          <Icon icon={faPencil} />
        </ActionIcon>
      )}
      {(booking?.status === 'drafting' ||
        booking?.status === 'negotiating') && (
        <ActionIcon
          onClick={handleDeleteProduct}
          size='xs'
          loading={isDeleting}
        >
          <Icon icon={faTrashCan} />
        </ActionIcon>
      )}
      <Menu withinPortal position='bottom-end'>
        <Menu.Target>
          <ActionIcon size='xs'>
            <Icon icon={faEllipsisV} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown style={{ border: 'none', padding: 0 }}>
          <CardBookingProductPreview bookingProduct={bookingProduct} />
        </Menu.Dropdown>
      </Menu>
    </Flex>
  )
}
